<template>
  <div class="rootDiv">
    <Tabs>
      <Tab title="各省酒店" label="">
        <div v-for="item in ProvinceList" :key="item.jDSF" style="margin-left: -0.5rem;margin-right: -0.5rem">
          <div class="title-div" style="position: relative">
            <span style="margin-top: 1rem">{{ item.jDSF }}</span>
            <span>{{ '（' + item.hotelList.length + '个）' }}</span>
            <img src="../../../assets/images/32/map.png" alt="" width="24" height="24"
                 @click="GoMap(item.hotelList)"
                 style="position: absolute;top: 50%;bottom: 50%;margin: auto">
          </div>
          <Cell :title="hotel.jDMC"
                v-for="hotel in item.hotelList"
                :key="hotel.iD" class="cellstyle"
                v-on:click.native="Go(hotel)"
                :is-link="true">
            <span style="color: #2986de">{{ hotel.jDPF === 0 ? '' : hotel.jDPF }}</span>
          </Cell>
        </div>
      </Tab>
      <Tab title="酒店地图" label="">
        <MapControl :center="getCenter()" :scale="14" :markers="getMarkers()"></MapControl>
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import {Cell, Indicator} from "mint-ui";
import {Tab, Tabs} from "vant";
import MapControl from "@/controls/MapControl";

export default {
  name: "StarHotel",
  components: {
    MapControl,
    Tab, Tabs, Cell
  },
  mounted() {
    window.test = this.test
    this.gethotelListByProvince()
    this.getAllHotel()
  },
  data() {
    return {
      AllHotels: [],
      ProvinceList: [],
      CommonList: [],
      token: localStorage.getItem('token'),
      getHotelListByProvinceUrl: '/api/whhly/getHotelListByProvince',
      getAllHotelUrl: '/api/whhly/getAllHotel',
    }
  },
  methods: {
    test(item) {
      this.$router.push({name: 'm_hotel_details', params: {id: item}})
    },
    getCenter() {
      if (this.AllHotels.length === 0)
        return {lng: 0, lat: 0}
      else
        return {lng: this.AllHotels[0].jDJD, lat: this.AllHotels[0].jDWD}
    },
    getMarkers() {
      let that = this
      let markers = []
      that.AllHotels.forEach(item => {
        let P = item.iD
        let image_div = '<div><img src="' + item.jDTP + '" width="300" alt=""></div>'
        let jqdh = '<div><span style="text-align: center;font-size: 1rem;color: blue">酒店电话：</span><span style="text-align: center;font-size: 1rem">' + item.jDDH + '</span></div>'
        let text_div = '<a href="javascript:test(\'' + P + '\')" style="color: #2986de;font-size: 1.2rem">' + item.jDMC + '</a>'
        let content = '<div>' + image_div + (item.jDDH ? jqdh : '') + text_div + '</div>'

        let m = {content: content, point: {lng: item.jDJD, lat: item.jDWD}}
        markers.push(m)
      })
      return markers
    },
    GoMap(hotelList) {
      let list = []
      hotelList.forEach(x => {
        let point = {title: x.jDMC, data: x}
        list.push(point)
      })
      this.$router.push({name: 'm_hotel_map', query: {point: list}})
    },
    Go(item) {
      this.$router.push({name: 'm_hotel_details', params: {viewModel: item}})
    },
    gethotelListByProvince() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getHotelListByProvinceUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.ProvinceList = response.data['responseData']
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    getAllHotel() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getAllHotelUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.AllHotels = response.data['responseData']
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.cellstyle {
  text-align: left;
}

.rootDiv {
  margin-top: -0.5rem;
}

.title-div {
  background-color: #8450C5;
  padding-top: 5px;
  padding-bottom: 5px;

  span {
    font-size: 1.4rem;
    color: white;
  }
}
</style>
